import 'daterangepicker';

document.addEventListener('DOMContentLoaded', function () {
	// Get the typeOfWorkSelection element by ID
	const typeOfWorkSelection = document.getElementById('typeOfWorkSelection');
	const addDateRangeButton = document.getElementById('addDateRange');
	let typeOfWork = '';

	if (!addDateRangeButton) {
		return;
	}

	function setTypeOfWork(value) {
		typeOfWork = value;

		changeAvailabilityTitle(typeOfWork);
	}

	function changeAvailabilityTitle(typeOfWork) {
		const availabilityTitle = document.getElementById('availabilityTitle');
		const availabilityTableFrom = document.getElementById('availabilityTableFrom');
		const availabilityTableTo = document.getElementById('availabilityTableTo');

		if (!availabilityTitle) {
			return;
		}

		if (typeOfWork === 'O') {
			availabilityTitle.textContent = 'Not Available';
			availabilityTableFrom.textContent = 'Not Available From';
			availabilityTableTo.textContent = 'Not Available To';
		} else if (typeOfWork === 'S') {
			availabilityTitle.textContent = 'Seasonal Availability';
			availabilityTableFrom.textContent = 'Availability From';
			availabilityTableTo.textContent = 'Availability To';
		}
	}

	// If type of work selection element exists, find the checked element
	if (typeOfWorkSelection) {
		const checkedElement = typeOfWorkSelection.querySelector('input:checked');
		if (checkedElement) {
			setTypeOfWork(checkedElement.value);
		}

		// Add event listener to type of work selection element
		typeOfWorkSelection.addEventListener('change', function (event) {
			const selectedElement = event.target;
			setTypeOfWork(selectedElement.value);
		});
	}


	$('#availabilityDateRange').daterangepicker({
		opens: 'right',
		locale: {
			format: 'DD/MM/YYYY'
		}
	});

	addDateRangeButton.addEventListener('click', function (e) {
		e.preventDefault();

		const dateRange = document.getElementById('availabilityDateRange').value;
		if (dateRange) {
			// Normalize the string and split on any kind of dash with surrounding spaces
			const [from, to] = dateRange.split(/\s*-\s*/);

			// Add the row to the table
			const table = document.querySelector('.availability__dates tbody');
			const newRow = `<tr>
            <td>${from}</td>
            <td>${to}</td>
            <td><button type="button" class="btn btn--remove remove-row"><i class="far fa-times"></i></button></td>
        </tr>`;
			table.insertAdjacentHTML('beforeend', newRow);

			// Update the availability ranges
			updateAvailabilityRanges();
		}

	});

	document.querySelector('.availability__dates').addEventListener('click', function (e) {
		// Check if the clicked element is a button or its child
		if (e.target.classList.contains('remove-row') || e.target.closest('.remove-row')) {
			// Find the closest `tr` and remove it
			e.target.closest('tr').remove();

			// Update the availability ranges
			updateAvailabilityRanges();
		}
	});

	// Function to update the hidden availability_ranges field
	function updateAvailabilityRanges() {
		const rows = document.querySelectorAll('.availability__dates tbody tr');
		const ranges = [];


		rows.forEach(row => {
			const from = row.children[0].textContent;
			const to = row.children[1].textContent;
			ranges.push(`${from},${to}`);
		});
		document.querySelector('input[name="availability_ranges"]').value = ranges.join(';');
	}


});